import React, { useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormGroup,
  Label,
  Table
} from "reactstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const InvoiceModals = ({
  generateModal,
  setGenerateModal,
  viewModal,
  setViewModal,
  selectedInvoice,
  bookingId,
  setBookingId,
  handleGenerateInvoice
}) => {
  const invoiceRef = useRef();
  const handleDownloadPDF = () => {
    if (!invoiceRef.current) return;
    html2canvas(invoiceRef.current, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`invoice_${selectedInvoice.invoice_number}.pdf`);
    });
  };
  const handleDownloadImage = () => {
    if (!invoiceRef.current) return;
    html2canvas(invoiceRef.current).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `invoice_${selectedInvoice.invoice_number}.png`;
      link.click();
    });
  };

  return (
    <>
      <Modal isOpen={generateModal} toggle={() => setGenerateModal(false)}>
        <ModalHeader toggle={() => setGenerateModal(false)}>
          Generate Invoice
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Booking ID</Label>
            <Input
              type="text"
              value={bookingId}
              onChange={(e) => setBookingId(e.target.value)}
              placeholder="Enter booking ID"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setGenerateModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleGenerateInvoice}>
            Generate
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
        <ModalHeader toggle={() => setViewModal(false)}>TAX INVOICE</ModalHeader>
        <ModalBody >
          {selectedInvoice && (
            <div
              ref={invoiceRef}
              className="border p-3"
              style={{
                fontSize: "14px",
                backgroundColor: "#e0e4e7ff",
                border: "2px solid #000",
                borderRadius: "1px",
                boxShadow: "0 0 10px rgba(0,0,0,0.2)"
              }}
            >
              <Table bordered style={{ border: "1.5px solid #000" }}>
                <tbody>
                  <tr className="text-center">
                    <td colSpan="3">
                      <h5>TAX INVOICE</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Customer GSTIN No.</strong>
                      <br />
                      {selectedInvoice.customer_gstin || "—"}
                    </td>
                    <td>
                      <strong>Advance Receipt Voucher No.</strong>
                      <br />
                      {selectedInvoice.advance_receipt_no || "Not Applicable"}
                    </td>
                    <td>
                      <strong>Transaction Category</strong>
                      <br />
                      {selectedInvoice.transaction_category || "B2C"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Customer Name</strong>
                      <br />
                      {selectedInvoice.customer_name}
                    </td>
                    <td>
                      <strong>Invoice No.</strong>
                      <br />
                      {selectedInvoice.invoice_number}
                    </td>
                    <td>
                      <strong>Date</strong>
                      <br />
                      {new Date(selectedInvoice.issue_date).toLocaleDateString()}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Location</strong>
                      <br />
                      {selectedInvoice.location}
                    </td>
                    <td>
                      <strong>Transaction Detail</strong>
                      <br />
                      {selectedInvoice.transaction_detail || "Regular"}
                    </td>
                    <td>
                      <strong>Transaction Type</strong>
                      <br />
                      {selectedInvoice.transaction_type || "Unregistered"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Place of Supply</strong>
                      <br />
                      {selectedInvoice.place_of_supply}
                    </td>
                    <td>
                      <strong>PNR No.</strong>
                      <br />
                      {selectedInvoice.pnr_no}
                    </td>
                    <td>
                      <strong>HSN/SAC Code</strong>
                      <br />
                      {selectedInvoice.hsn_code}
                    </td>
                  </tr>
                </tbody>
              </Table>

              {/* Middle Section */}
              <div className="row">
                <div className="col-6">
                  <h6><strong>Travel Information</strong></h6>
                  <Table bordered style={{ border: "1.5px solid #000" }}>
                    <tbody>
                      <tr>
                        <td><strong>Bus Operator Name</strong></td>
                        <td>{selectedInvoice.operator_name}</td>
                      </tr>
                      <tr>
                        <td><strong>Origin</strong></td>
                        <td>{selectedInvoice.origin}</td>
                      </tr>
                      <tr>
                        <td><strong>Destination</strong></td>
                        <td>{selectedInvoice.destination}</td>
                      </tr>
                      <tr>
                        <td><strong>Invoice Value (In words)</strong></td>
                        <td>{selectedInvoice.amount_in_words}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="col-6">
                  <h6><strong>Payment Breakup</strong></h6>
                  <Table bordered style={{ border: "1.5px solid #000" }}>
                    <tbody>
                      <tr>
                        <td><strong>Bus fare</strong></td>
                        <td>₹{selectedInvoice.subtotal_amount}</td>
                      </tr>
                      <tr>
                        <td><strong>IGST @0%</strong></td>
                        <td>₹0.00</td>
                      </tr>
                      <tr>
                        <td><strong>CGST @2.5%</strong></td>
                        <td>₹{selectedInvoice.cgst_amount}</td>
                      </tr>
                      <tr>
                        <td><strong>SGST @2.5%</strong></td>
                        <td>₹{selectedInvoice.sgst_amount}</td>
                      </tr>
                      <tr className="table-active">
                        <td><strong>Total Invoice Value</strong></td>
                        <td><strong>₹{selectedInvoice.total_amount}</strong></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>

              <p className="mt-3 text-muted" style={{ fontSize: "12px" }}>
                This is a computer generated Invoice and does not require Signature/Stamp.
              </p>
              <Table bordered style={{ border: "1.5px solid #000" }}>
                <tbody>
                  <tr>
                    <td><strong>PAN</strong><br />{selectedInvoice.pan}</td>
                    <td><strong>GST No</strong><br />{selectedInvoice.gst_no}</td>
                    <td><strong>CIN</strong><br />{selectedInvoice.cin}</td>
                  </tr>
                  <tr>
                    <td colSpan="3"><strong>Service Description:</strong> Passenger Transportation Services</td>
                  </tr>
                  <tr>
                    <td colSpan="3">{selectedInvoice.company_address}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setViewModal(false)}>Close</Button>
          {selectedInvoice && (
            <>
              <Button color="success" onClick={handleDownloadPDF}>Download PDF</Button>
              <Button color="info" onClick={handleDownloadImage}>Download Image</Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default InvoiceModals;
